export type DictWithList<T> = {
  [key: string]: T[];
};
